import { render, staticRenderFns } from "./index-event.vue?vue&type=template&id=0b0c51bb&"
import script from "./index-event.vue?vue&type=script&lang=js&"
export * from "./index-event.vue?vue&type=script&lang=js&"
import style0 from "./index-event.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports